var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("table", { staticClass: "table table-striped" }, [
    _vm._m(0),
    _vm._v(" "),
    _vm.answers
      ? _c(
          "tbody",
          [
            _vm._l(_vm.answers.pages, function(page) {
              return _vm._l(page.elements, function(element) {
                return _c("tr", [
                  _c("td", [
                    _vm._v(" " + _vm._s(element.title || element.name))
                  ]),
                  _vm._v(" "),
                  _c("td", {
                    domProps: {
                      innerHTML: _vm._s(_vm.formatResult(element.result))
                    }
                  })
                ])
              })
            })
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [_c("tr", [_c("th"), _vm._v(" "), _c("th")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }